import React, { Component} from 'react';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from "react-toastify";
import plane from '../images/plane_icon2.png';
import {saveImage} from '../services/aircraftImageService';
import {saveAircraft} from '../services/aircraftService';
import {getMainImage} from '../services/aircraftImageService';

class ImageWikiForm extends Component {
    state = { 
        base64TextString: "",
        wikilink:"",
        image:"",
        updated: false
    }

    async componentDidMount(){
        const data = await getMainImage(this.props.aircraft.aircraft_id);
      //  console.log(data);
        if(data.data)
            this.setState({ image: data.data.aircraft_image, wikilink: this.props.aircraft.wikilink, updated:false});
    }

    onFileChange(e) {
        const file = e.target.files[0];
        console.log(file);

        if(file){
            const reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(file);
        }
    }

    handleWikiChange = (e) => {
        this.setState({wikilink: e.target.value, updated: true});
    }

    _handleReaderLoaded(readEvt) {
        let binaryString = readEvt.target.result;
        const base64String = btoa(binaryString);
        
        const pic = document.getElementById("plane-picture");
        pic.src = "data:image/png;base64," + base64String;
        pic.height = 300;

        this.setState({base64TextString: base64String, updated:true});
    }

    handleFormSubmit = (e) => {
        e.preventDefault();

        if(!this.state.updated){
            toast.warning("You have not made any changes! Can't save!",{position:"bottom-right"});
            return; 
        }

        console.log(e);
        const { base64TextString: base64String, wikilink} = this.state;
        const { aircraft } = this.props;

        let payload = {}
        payload.aircraft_image = base64String;
        payload.aircraft_id = aircraft.aircraft_id;
        payload.show_main_image = true;
        payload.owner_id = 1;
        saveImage(payload);

        aircraft.wikilink = wikilink;
        saveAircraft(aircraft);

        this.props.onShowDetail(aircraft.aircraft_id);
    }

    render() { 
        const { wikilink } =  this.state;
        const { aircraft } = this.props;
  
  //      toast.info("howdy");

        let img = "";
        if(this.state.image)
            img = "data:image/png;base64," + this.state.image;
        else
            img = plane;

    return ( 
            <div>
                <ToastContainer></ToastContainer>
            <h4>Edit Aircraft - {aircraft.aircraft_name}</h4>
            <form onSubmit={this.handleFormSubmit}>
                <table className="formTable">
                    <tbody>
                    <tr><td colSpan="2"><img src={img} alt='aircraft' id="plane-picture" className="aircraftPhoto" style={{marginRight:20}}/>
                        <input type="file" name="btnBrowse" accept=".jpeg, .png, .jpg" onChange={(e) => this.onFileChange(e)}></input></td>  
                    </tr>
                    <tr>
                        <td>Wikipedia Link</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td><textarea name='wikilink' id="wikilink" rows="3" cols="90" placeholder="Type or paste link here" 
                            value={wikilink} onChange={this.handleWikiChange}></textarea></td>
                        <td></td>
                    </tr>
                    <tr><td><button className="btn btn-primary" style={{marginRight:20}}>Save</button>
                            <Button className="btn btn-primary" onClick={(e) => this.props.onShowDetail(aircraft.aircraft_id)}>Cancel</Button>
                        </td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>
            </form>
        </div>
         );
    }
}
 
export default ImageWikiForm;
